/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listTeamsParamsQueryMax = 100;

export const listTeamsParamsCursorMax = 512;

export const listTeamsParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listTeamsParamsLimitDefault = 50;
export const listTeamsParamsLimitMax = 100;

export const ListTeamsParams = zod.object({
  query: zod.string().max(listTeamsParamsQueryMax).optional(),
  active: zod.string().optional(),
  cursor: zod
    .string()
    .min(1)
    .max(listTeamsParamsCursorMax)
    .regex(listTeamsParamsCursorRegExp)
    .optional(),
  limit: zod.int().min(1).max(listTeamsParamsLimitMax).default(listTeamsParamsLimitDefault),
});

export type ListTeamsParams = zod.input<typeof ListTeamsParams>;
export type ListTeamsParamsOutput = zod.output<typeof ListTeamsParams>;
